import { render, staticRenderFns } from "./CompanyItemListView.vue?vue&type=template&id=af454794&scoped=true"
import script from "./CompanyItemListView.vue?vue&type=script&lang=js"
export * from "./CompanyItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af454794",
  null
  
)

export default component.exports